import React, { useEffect, useState } from "react";
import "./Checkout.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Checkout = () => {
  const countryStateCityData = {
    India: {
      Gujarat: [
        "Ahmedabad",
        "Surat",
        "Vadodara",
        "Rajkot",
        "Gandhinagar",
        "Bhavnagar",
      ],
    },
    USA: {
      California: [
        "Los Angeles",
        "San Diego",
        "San Francisco",
        "Sacramento",
        "Fresno",
        "San Jose",
      ],
    },
  };

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isStateDisabled, setIsStateDisabled] = useState(true);
  const [isCityDisabled, setIsCityDisabled] = useState(true);

  const handleCountryChange = (event) => {
    const country = event.target.value;
    setSelectedCountry(country);
    setSelectedState("");
    setCities([]);
    if (country && countryStateCityData[country]) {
      setStates(Object.keys(countryStateCityData[country]));
      setIsStateDisabled(false);
      setIsCityDisabled(true);
    } else {
      setStates([]);
      setIsStateDisabled(true);
      setIsCityDisabled(true);
    }
  };

  const handleStateChange = (event) => {
    const state = event.target.value;
    setSelectedState(state);
    if (state && countryStateCityData[selectedCountry][state]) {
      setCities(countryStateCityData[selectedCountry][state]);
      setIsCityDisabled(false);
    } else {
      setCities([]);
      setIsCityDisabled(true);
    }
  };

  const [cartItems, setCartItems] = useState([]);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");

  const fetchCart = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch("https://backend.rubiajewels.com/api/cart", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setCartItems(data);
      } else if (response.status === 401) {
        console.log("Access token expired, refreshing...");

        const refreshToken = localStorage.getItem("refreshToken");
        const refreshResponse = await fetch(
          "https://backend.rubiajewels.com/api/refresh-token",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ refreshToken }),
          }
        );

        if (refreshResponse.ok) {
          const { accessToken } = await refreshResponse.json();
          localStorage.setItem("token", accessToken);

          return fetchCart();
        } else {
          console.error("Unable to refresh token. Please log in again.");
          setError("Session expired. Please log in again.");
        }
      } else {
        console.error("Failed to fetch cart items:", response.status);
        setError("Failed to fetch cart items.");
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
      setError("Error fetching cart items.");
    }
  };

  useEffect(() => {
    if (token) {
      fetchCart();
    } else {
      setError("You are not logged in. Please log in to view your cart.");
    }
  }, [token]);

  useEffect(() => {
    axios
      .get("https://backend.rubiajewels.com/api/cart", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const itemsWithQuantity = response.data.map((item) => ({
          ...item,
          quantity: Number(item.quantity) || 1,
        }));

        setCartItems(itemsWithQuantity);
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }, []);

  const handleCheckout = async () => {
    if (!cartItems.length) {
      alert("Your cart is empty");
      return;
    }

    const orderData = {
      userId: localStorage.getItem("userId"),
      email: document.querySelector(".contact-input").value,
      firstName: document.querySelector(".form-input[placeholder='First name']")
        .value,
      lastName: document.querySelector(".form-input[placeholder='Last name']")
        .value,
      address: document.querySelector(".form-input[placeholder='Address']")
        .value,
      country: selectedCountry,
      state: selectedState,
      city: document.getElementById("city").value,
      pincode: document.querySelector(".form-input[placeholder='PIN code']")
        .value,
      phone: document.querySelector(".form-input[placeholder='Phone']").value,
      cartItems: cartItems,
      totalAmount: cartItems.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      ),
    };

    try {
      const response = await axios.post(
        "https://backend.rubiajewels.com/orders",
        orderData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 201) {
        toast.success("Order placed successfully!", {
          position: "top-right",
          autoClose: 3000,
        });

        // 🔹 Step 1: Call API to clear cart from database
        await axios.delete("https://backend.rubiajewels.com/api/cart", {
          headers: { Authorization: `Bearer ${token}` },
        });

        // 🔹 Step 2: Clear local cart state & reset form fields
        setSelectedCountry("");
        setSelectedState("");
        setStates([]);
        setCities([]);
        setIsStateDisabled(true);
        setIsCityDisabled(true);
        document
          .querySelectorAll(".form-input")
          .forEach((input) => (input.value = ""));
        setCartItems([]);
        localStorage.removeItem("cart");
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order. Please try again.");
    }

    localStorage.setItem("orderDate", new Date().toISOString());
    setReturnEnabled(true);
  };

  // State for return order popup
  const [showReturnPopup, setShowReturnPopup] = useState(false);
  const [returnReason, setReturnReason] = useState("");
  const [returnImage, setReturnImage] = useState(null);
  const [returnEmail, setReturnEmail] = useState("");
  const [returnPhone, setReturnPhone] = useState("");
  const [returnAmount, setReturnAmount] = useState("");
  const [returnEnabled, setReturnEnabled] = useState(false);

  useEffect(() => {
    const storedOrderDate = localStorage.getItem("orderDate");
    console.log("Stored Order Date:", storedOrderDate);
    if (storedOrderDate) {
      const orderTime = new Date(storedOrderDate);
      const currentTime = new Date();
      const diffDays = (currentTime - orderTime) / (1000 * 60 * 60 * 24);
      console.log("Days difference:", diffDays);
      if (diffDays <= 7) {
        setReturnEnabled(true);
      }
    }
  }, []);
  console.log("Return Enabled:", returnEnabled);

  const handleReturnSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("userId", localStorage.getItem("userId"));
    formData.append("reason", returnReason);
    formData.append("proofImage", returnImage);
    formData.append("email", returnEmail);
    formData.append("phone", returnPhone);
    formData.append("amount", returnAmount);

    console.log("Submitting return order with data:");
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await axios.post(
        "https://backend.rubiajewels.com/return-orders/submit",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("Return Order Submitted Successfully.");
      console.log(response.data.message);

      // 🔹 Reset form fields after successful submission
      setReturnReason("");
      setReturnImage(null);
      setReturnEmail("");
      setReturnPhone("");
      setReturnAmount("");

      // 🔹 Manually clear file input
      if (document.getElementById("proofImageInput")) {
        document.getElementById("proofImageInput").value = "";
      }

      // 🔹 Close the popup
      setShowReturnPopup(false);
    } catch (error) {
      console.error("Error submitting return order:", error);
    }
  };

  return (
    <div className="checkout-page">
      <ToastContainer />
      <div className="checkout-left">
        <div className="contact-section">
          <h5 className="contact-h5">Contact</h5>
          <input
            type="email"
            placeholder="Email"
            className="form-input contact-input"
          />
        </div>

        <div className="shipping-section">
          <h5 className="contact-h5">Shipping address</h5>

          <div className="name-inputs">
            <input
              type="text"
              placeholder="First name"
              className="form-input"
            />
            <input type="text" placeholder="Last name" className="form-input" />
          </div>
          <input type="text" placeholder="Address" className="form-input" />
          <select className="form-input-select" onChange={handleCountryChange}>
            <option value="">Country / Region</option>
            {Object.keys(countryStateCityData).map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>

          <div className="location-inputs">
            <select
              className="form-input"
              onChange={handleStateChange}
              disabled={isStateDisabled}
            >
              <option value="">State</option>
              {states.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>

            <select className="form-input" disabled={isCityDisabled} id="city">
              <option value="">City</option>
              {cities.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
            <input type="text" placeholder="PIN code" className="form-input" />
          </div>
          <input type="text" placeholder="Phone" className="form-input" />
        </div>
        <div className="buttons-container">
          <button className="continue" onClick={handleCheckout}>
            Continue
          </button>
          {returnEnabled && (
            <button
              className="return-order-btn continue"
              onClick={() => setShowReturnPopup(true)}
            >
              Return Order
            </button>
          )}
        </div>
        {showReturnPopup && (
          <div className="return-popup">
            <h3>Return Order</h3>
            <form onSubmit={handleReturnSubmit}>
              <textarea
                className="form-input"
                placeholder="Reason for return"
                value={returnReason}
                onChange={(e) => setReturnReason(e.target.value)}
              />
              <input
                className="form-input"
                type="file"
                id="proofImageInput"
                onChange={(e) => setReturnImage(e.target.files[0])}
              />
              <input
                className="form-input"
                type="email"
                placeholder="Email"
                value={returnEmail}
                onChange={(e) => setReturnEmail(e.target.value)}
              />
              <input
                className="form-input"
                type="text"
                placeholder="Phone Number"
                value={returnPhone}
                onChange={(e) => setReturnPhone(e.target.value)}
              />
              <input
                className="form-input"
                type="text"
                placeholder="Amount"
                value={returnAmount}
                onChange={(e) => setReturnAmount(e.target.value)}
              />
              <div className="buttons-container">
                <button type="submit" className="continue">
                  Submit
                </button>
                <button
                  type="button"
                  className="continue"
                  onClick={() => setShowReturnPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
          
      <div className="checkout-right">
        <div className="summary-section">
          {cartItems.length > 0 ? (
            cartItems.map((item) => (
              <div className="cart-item" key={item._id}>
                <img
                  src={`https://backend.rubiajewels.com/${item.image.replace(
                    /\\/g,
                    "/"
                  )}`}
                  alt={item.name}
                  className="product-image"
                />
                <div className="product-details">
                  <h2 className="product-title">{item.name}</h2>
                  <div className="product-variant">
                    <p>Selected Color : {item.color || "Not Selected"}</p>
                    <p>Selected Size : {item.size || "Not Selected"}</p>
                    <p>Selected Karat : {item.karat || "Not Selected"}</p>
                    <p>Selected Stone : {item.stone || "Not Selected"}</p>
                    <p>Quantity : {item.quantity}</p>
                  </div>
                </div>
                <div className="product-pricing">
                  <p className="original-price">${item.originalPrice}</p>
                  <p className="discounted-price">${item.price}</p>
                </div>
              </div>
            ))
          ) : (
            <p>Your Checkout is empty</p>
          )}

          <div className="total-row">
            <h6>Total</h6>
            <p className="subtotal-amount">
              $
              {cartItems
                .reduce((acc, item) => acc + item.price * item.quantity, 0)
                .toFixed(2)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
